import React, { useState } from "react";
import axios from "axios";
import "./AddClients.css";

const AddClients = ({ isOpen, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    // =========================
    // CLIENT INFO
    // =========================
    name: "",
    address: "",
    mobile: "",
    gmail: "",

    // =========================
    // NETWORK INFO
    // =========================
    network_name: "",
    network_location: "",
    notes: "",

    // =========================
    // HW INFO
    // =========================
    sl_id: "",
    public_ip: "",
    lan_ip: "",
    uuid: "",
    machine_id: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // =========================
  // SUBMIT CLIENT
  // =========================
  const handleSubmit = async () => {
    try {
      setLoading(true);

      const res = await axios.post(
        "https://streamsrvbac.n-tools.info/keymanage/clients/create",
        form
      );

      alert(res.data.message || "Client Created Successfully");

      onSuccess?.();
      onClose();

      // reset form
      setForm({
        name: "",
        address: "",
        mobile: "",
        gmail: "",
        network_name: "",
        network_location: "",
        notes: "",
        sl_id: "",
        public_ip: "",
        lan_ip: "",
        uuid: "",
        machine_id: "",
      });

    } catch (err) {
      alert(err.response?.data?.error || "Failed to create client");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">

      <div className="modal-box wide">

        {/* HEADER */}
        <div className="modal-header">
          <h2>Add New Client</h2>
          <button onClick={onClose}>✖</button>
        </div>

        {/* =========================
            CLIENT INFORMATION
        ========================= */}
        <h3>Client Information</h3>

        <input name="name" placeholder="Name" onChange={handleChange} />
        <input name="address" placeholder="Address" onChange={handleChange} />
        <input name="mobile" placeholder="Mobile" onChange={handleChange} />
        <input name="gmail" placeholder="Gmail" onChange={handleChange} />

        {/* =========================
            NETWORK INFORMATION
        ========================= */}
        <h3>Network Information</h3>

        <input name="network_name" placeholder="Network Name" onChange={handleChange} />
        <input name="network_location" placeholder="Network Location" onChange={handleChange} />
        <textarea name="notes" placeholder="Notes" onChange={handleChange} />

        {/* =========================
            HW INFORMATION
        ========================= */}
        <h3>Hardware Information</h3>

        <input name="sl_id" placeholder="SL / ID" onChange={handleChange} />
        <input name="public_ip" placeholder="Public IP" onChange={handleChange} />
        <input name="lan_ip" placeholder="LAN IP" onChange={handleChange} />
        <input name="uuid" placeholder="UUID" onChange={handleChange} />
        <input name="machine_id" placeholder="Machine ID" onChange={handleChange} />

        {/* ACTION */}
        <div className="modal-actions">
          <button
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Saving..." : "Create Client"}
          </button>
        </div>

      </div>

    </div>
  );
};

export default AddClients;